import { useRoomSession } from '../context/room_session';
import { useObservable } from './rxjs';
export function useBookmarkToSelect() {
    const roomSession = useRoomSession();
    const [bookmarkToSelect] = useObservable(roomSession.bookmarks.bookmarkToSelect);
    const clearBookmarkToSelect = () => {
        roomSession.bookmarks.clearBookmarkToSelect();
    };
    return [bookmarkToSelect, clearBookmarkToSelect];
}
//# sourceMappingURL=use_bookmark_to_select.js.map